import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
export const GridContainerTestId = 'serp-gridcontainer-testid';
export const GridContainer = ({ children, gridTemplateColumnsBase, gridTemplateColumnsXl }) => (_jsx(Box, { position: "relative", display: "grid", maxWidth: "1280px", width: "100%", gridTemplateColumns: {
        'breakpoint.base': gridTemplateColumnsBase,
        'breakpoint.xl': gridTemplateColumnsXl,
    }, columnGap: { 'breakpoint.base': 'spacing.none', 'breakpoint.sm': 'spacing.64' }, rowGap: "spacing.4", paddingHorizontal: {
        'breakpoint.base': 'spacing.16',
        'breakpoint.sm': 'spacing.32',
    }, paddingVertical: {
        'breakpoint.base': 'spacing.16',
        'breakpoint.sm': 'spacing.24',
    }, marginHorizontal: "auto", testId: GridContainerTestId, children: children }));
